import { render, staticRenderFns } from "./StateStratalisPublication.vue?vue&type=template&id=13e1d3d4&scoped=true&lang=html&"
import script from "./StateStratalisPublication.vue?vue&type=script&lang=js&"
export * from "./StateStratalisPublication.vue?vue&type=script&lang=js&"
import style0 from "./StateStratalisPublication.vue?vue&type=style&index=0&id=13e1d3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1d3d4",
  null
  
)

component.options.__file = "StateStratalisPublication.vue"
export default component.exports